import type { AcError } from '@bayer-int/portletce-aclibv2';

import { AppError } from './AppError';

export class AclibError extends AppError {
    constructor(
        originalError: unknown,
        message: string,
        severity: 'WARN' | 'ERROR' = 'ERROR',
        details?: string[],
    ) {
        super(
            severity === 'WARN' ? 'Aclib Warning' : 'Aclib Error',
            originalError,
            message,
            details,
            severity,
        );
    }

    public static fromAclib(error: AcError): AclibError {
        const { title, description, severity } = error.toFormattedMessage();

        return new AclibError(error, title, severity, [description]);
    }
}

export const createAclibError = (originalError: unknown, message = `Rendering failed`) =>
    new AclibError(originalError, message);
